import _ from "lodash";

export default {

   methods: { 

        registerSortClickCallback(columns, callback, startedSorting = []) {

            let isTouchableDevice = ("ontouchstart" in document.documentElement);
            let sortedColumns     = [];
            let ctrlClick         = 0;
            let self              = this;

            _.map(startedSorting, sorting => {
                _.map(sorting, (direction, columnId) => {
                    sortedColumns.push({ columnId: columnId, direction: direction });
                });
            });
            

            function normalizedSorting() {
                let sorting = [];
                sortedColumns.map(e => {
                    sorting.push({ [e.columnId] : e.direction});
                })
                return sorting;
            }

            function columnDefaultSort(column) {
                return column.defaultSort === undefined ? 'asc' : column.defaultSort;
            }

            function keyUp(event) {
                if (event.keyCode === 17) {//CTRL
                    setTimeout(() => { document.removeEventListener('keyup', keyUp); }, 1);
                    if( ctrlClick > 0 ) {
                        ctrlClick = 0;
                        self.$nextTick(function(){
                            if( typeof callback === 'function' ) {
                                callback(normalizedSorting(), true);
                            }
                        });
                    }                                        
                }  
            }                    
            
            columns.map(function(column) {
                column.meta        = column.meta        || {};
                column.meta.events = column.meta.events || {};
                column.meta.events.onSortClick = function(event) {

                    event.stopPropagation();

                    let column  = this;
                    let sorting = null;

                    if( event.ctrlKey === true ) {
                        document.addEventListener('keyup', keyUp);
                        ctrlClick++;                       
                    }

                    let index = sortedColumns.findIndex( e => e.columnId == column.id );
                    if( index !== -1 ) {
                        sorting = sortedColumns[index];
                        sorting.direction = ( sorting.direction === 'asc' ) ? 'desc' : 'asc';
                        if ( sorting.direction === columnDefaultSort(column) ) { 
                            sorting = null;
                        }
                    } else {
                        sorting = { columnId: column.id, direction: columnDefaultSort(column) };
                    }

                    if( ( event.ctrlKey === false || ctrlClick === 1 ) && !isTouchableDevice ) {
                        sortedColumns = [];
                    }

                    if( index === -1 ) {                        
                        sortedColumns.push(sorting);
                    } else {
                        if( sorting === null ) {                            
                            sortedColumns.splice(index, 1);
                        } else {     
                            index = ( sortedColumns.length  < index ) ? sortedColumns.length : index;                       
                            sortedColumns[index] = sorting;
                        }
                    }                    

                    self.$nextTick(function(){
                        if( typeof callback === 'function' ) {
                            callback(normalizedSorting(), !event.ctrlKey);
                        }
                    });
                } 
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/components/common/table_v3/mixin/sortable.mixin.js